import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { FormProvider } from "react-hook-form";
const FormComponent = ({ form, onSubmit, children, dataTestId, onKeyDown, className }, ref) => {
    const { handleSubmit } = form;
    const onKeyDownHandler = (e) => onKeyDown?.(e);
    return (_jsx("form", { "data-testid": dataTestId, onSubmit: onSubmit && handleSubmit(onSubmit), onKeyDown: onKeyDownHandler, className: className, ref: ref, children: _jsx(FormProvider, { ...form, children: children }) }));
};
export const Form = forwardRef(FormComponent);
//# sourceMappingURL=Form.js.map